export default __webpack_public_path__ + "static/media/lahete.e30e76e7.svg";